import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import Fld from "../../components/common/Fld";
import Dlg from "../../components/common/Dlg";
import { ABt, filt, exportCSV } from "../AdminUI";

export default function LeadsTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("leads", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("leads", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12 }}>
        <ABt onClick={() => exportCSV("leads", db.leads || [], [["Name", "name"], ["Email", "email"], ["Phone", "phone"], ["Service", "service"], ["Company", "company"], ["Status", "status"], ["Date", "date"]], toast)}>Export CSV</ABt>
        <ABt variant="orange" onClick={() => { setForm({ name: "", email: "", phone: "", service: "Staffing", company: "", message: "", status: "new", date: new Date().toISOString().slice(0, 10) }); setModal(true); }}>+ Add Lead</ABt>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {filt(db.leads, ["name", "email", "service", "status"], srch).map(l => (
          <div key={l.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "15px 17px", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8, alignItems: "flex-start" }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
                  <span style={{ fontWeight: 700, color: C.blue, fontSize: 14 }}>{l.name}</span>
                  <Badge v={l.status} />
                  <span style={{ fontSize: 11, color: C.orange, fontWeight: 600, background: "rgba(232,89,60,.07)", padding: "2px 8px", borderRadius: 20 }}>{l.service}</span>
                </div>
                <div style={{ fontSize: 12, color: "#64748b", marginBottom: 6 }}>{l.email} · {l.phone}{l.company ? " · " + l.company : ""}</div>
                <div style={{ fontSize: 13, background: "#f8fafc", padding: "7px 11px", borderRadius: 7, lineHeight: 1.55, border: "1px solid #e2e8f0" }}>{l.message}</div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 5 }}>{l.date}</div>
              </div>
              <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
                <select value={l.status} onChange={e => save({ ...l, status: e.target.value })} style={{ padding: "5px 7px", border: "1.5px solid #e2e8f0", borderRadius: 6, fontSize: 12, cursor: "pointer", background: "#f8fafc" }}>
                  {["new", "contacted", "in-progress", "converted", "lost"].map(st => <option key={st} value={st}>{st}</option>)}
                </select>
                <ABt onClick={() => { setForm({ ...l }); setModal(true); }}>Edit</ABt>
                <ABt variant="red" onClick={() => del(l.id)}>Del</ABt>
              </div>
            </div>
          </div>
        ))}
        {!(db.leads || []).length && <div style={{ textAlign: "center", padding: 34, color: "#94a3b8", background: "#fff", borderRadius: 11 }}>No leads yet.</div>}
      </div>

      {modal && <Dlg title={form.id ? "Edit Lead" : "Add Lead"} onClose={close}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Name" value={form.name || ""} onChange={fs("name")} /><Fld label="Phone" value={form.phone || ""} onChange={fs("phone")} /></div>
        <Fld label="Email" value={form.email || ""} onChange={fs("email")} type="email" />
        <Fld label="Company" value={form.company || ""} onChange={fs("company")} />
        <Fld label="Service" value={form.service || "Staffing"} onChange={fs("service")} opts={["Staffing", "Software Development", "Cyclojet Lab", "Valuation", "Other"]} />
        <Fld label="Status" value={form.status || "new"} onChange={fs("status")} opts={["new", "contacted", "in-progress", "converted", "lost"]} />
        <Fld label="Message" value={form.message || ""} onChange={fs("message")} rows={3} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Add"} Lead</ABt>
      </Dlg>}
    </>
  );
}
